import { Layout } from "providers/Layout";
import { useLocation } from "react-router-dom";
import {
  BadgeSize,
  ButtonSize,
  BadgeSkeleton,
  ButtonSkeleton,
  TextSkeleton
} from "shared/components";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { Card } from "shared/components/Card";

const statSkeletonCellClassName =
  "border-l border-t border-alpha-40 first:border-l-0 px-6 py-4 h-24 flex flex-col justify-center gap-2";

export const LoadingSkeletonSlice = () => {
  const { pathname } = useLocation();

  return (
    <Layout
      header={
        <div>
          <div className="flex h-10 items-center justify-between border-b border-alpha-40 px-3 lg:px-6 lg:flex-nowrap flex-wrap">
            <BreadCrumbs
              crumbs={[
                { title: "Applications", href: "/applications" },
                { title: "", href: pathname }
              ]}
            />

            <div className="flex gap-2">
              <ButtonSkeleton size={ButtonSize.SM} />
              <ButtonSkeleton size={ButtonSize.SM} />
            </div>
          </div>

          <div className="flex items-center justify-between px-3 py-3 lg:px-6 lg:py-3 flex-wrap lg:flex-nowrap min-h-[88px]">
            <div className="flex flex-col gap-2">
              <TextSkeleton size="xl" className="w-[180px]" />
              <div className="flex items-center gap-3">
                <BadgeSkeleton size={BadgeSize.BASE} className="w-[130px]" />
                <BadgeSkeleton size={BadgeSize.BASE} className="w-[130px]" />
              </div>
            </div>

            <div className="flex items-center gap-2">
              <ButtonSkeleton size={ButtonSize.SM} className="w-[185px]" />
              <ButtonSkeleton size={ButtonSize.SM} className="w-[85px]" />
              <ButtonSkeleton size={ButtonSize.SM} className="w-[40px]" />
              <ButtonSkeleton size={ButtonSize.SM} className="w-[130px]" />
            </div>
          </div>

          <div className="border-t border-alpha-40 px-3 py-2 lg:px-6">
            <div className="flex h-9 items-center gap-1">
              <BadgeSkeleton size={BadgeSize.BASE} className="w-[150px]" />
              <BadgeSkeleton size={BadgeSize.BASE} className="w-[130px]" />
              <BadgeSkeleton size={BadgeSize.BASE} className="w-[130px]" />
            </div>
          </div>
        </div>
      }
    >
      <Card className="w-full">
        <div className="flex items-center gap-4 px-6 py-4">
          <div className="size-11 shrink-0 rounded-lg bg-alpha-40" />
          <div className="min-w-0 flex-1 space-y-2">
            <TextSkeleton size="base" className="w-[220px]" />
            <TextSkeleton size="sm" className="w-[280px]" />
          </div>
        </div>

        <div className="grid w-full grid-cols-2 lg:grid-cols-4">
          <div className={statSkeletonCellClassName}>
            <TextSkeleton size="xs" className="w-[80px]" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div className={statSkeletonCellClassName}>
            <TextSkeleton size="xs" className="w-[80px]" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div className={statSkeletonCellClassName}>
            <TextSkeleton size="xs" className="w-[80px]" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div className={statSkeletonCellClassName}>
            <TextSkeleton size="xs" className="w-[80px]" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
        </div>

        <div className="grid w-full grid-cols-2 lg:grid-cols-4">
          <div className={`${statSkeletonCellClassName} border-b`}>
            <TextSkeleton size="xs" className="w-[80px]" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div className={`${statSkeletonCellClassName} border-b`}>
            <TextSkeleton size="xs" className="w-[80px]" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div className={`${statSkeletonCellClassName} border-b`}>
            <TextSkeleton size="xs" className="w-[80px]" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div className={`${statSkeletonCellClassName} border-b`}>
            <TextSkeleton size="xs" className="w-[80px]" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
        </div>
      </Card>

      <div className="flex gap-4 mt-6">
        <Card className="h-[274px] w-[300px] shrink-0 flex flex-col p-6 justify-center">
          <div className="w-full h-[100px] rounded-lg bg-alpha-40" />

          <ButtonSkeleton size={ButtonSize.SM} className="w-full mt-auto" />
        </Card>
        <Card className="h-[274px] w-[300px] shrink-0 flex flex-col p-6 justify-center gap-4">
          <div className="w-full h-[100px] rounded-lg bg-alpha-40" />
          <TextSkeleton size="sm" className="w-full" />
        </Card>
      </div>
    </Layout>
  );
};
